/** @jsxImportSource @emotion/react */

import { Theme, ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { ReactNode } from 'react';

type ThemeProviderProps = {
  children: ReactNode;
  theme?: Theme;
};

export const ThemeProvider = ({ theme, ...props }: ThemeProviderProps) => {
  return (
    <EmotionThemeProvider
      {...props}
      theme={{
        color: {
          black: '#000',
          greyLight: '#f5f5f5',
          greyMedium: '#808386',
          orange: '#f46508',
          pink: '#e43896',
          primary: '#a71930',
          slate: '#445560',
          slateDark: '#293339',
          softGrey: '#b0b7bc',
          teal: '#569fae',
          white: '#fff'
        },
        fontFamily: {
          body:
            "'proxima-nova', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
          heading: 'Literata, Georgia, serif'
        },
        fontSizes: [10, 12, 14, 16, 18, 20, 24, 28, 32, 42, 48, 68],
        fontWeights: {
          regular: 400,
          semibold: 600,
          bold: 700
        },
        shadows: {
          card: '0px 0.25rem 0.5rem 0px #000000 15%'
        }
      }}
    />
  );
};

ThemeProvider.displayName = 'ThemeProvider';
